import React from 'react';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const PublishedColumn = ColumnTree.defineNode(
  'published',
  ({ sortDirection, sortColumn, setSort }) => ({
    title: (
      <div>
        <a
          href="#published"
          className={classnames('icon-sort', 'sortem', {
            [sortDirection]: sortColumn === 'created',
          })}
          onClick={() => setSort('created')}
        >
          <FormattedMessage
            id="marketplace-table-heading-published"
            description="Order published time, repeated for cell headings"
            defaultMessage="Published at"
          />
        </a>
      </div>
    ),
    children: [
      {
        title: '',
        key: 'published',
        className: 'col-published',
        render: (text, record, index) => (
          <div className="td-content">
            <span className="tiny-label">
              <FormattedMessage
                id="marketplace-table-heading-published"
                description="Order published time, repeated for cell headings"
                defaultMessage="Published at"
              />
            </span>
            <FormattedDate
              value={dayjs(record.created).toDate()}
              day="2-digit"
              month="short"
              year="numeric"
            />{' '}
            <FormattedTime
              value={dayjs(record.created).toDate()}
              hour="2-digit"
              minute="2-digit"
              hour12={false}
            />
          </div>
        ),
      },
    ],
  })
);
